// The HTML5 Advert needs to know the parent frame origin
// for secure cross-frame messaging.
export function buildIframeSource(source) {
  const url = new URL(window.location);
  const glue = source.match(/\?/) ? '&' : '?';

  return `${source}${glue}_origin=${url.origin}`;
}
